import t from"react";import{mdiPrinterOutline as r}from"@mdi/js";import{MdIcon as i}from"./MdIcon.js";const o=({id:o="print",title:e="Print",...m})=>t.createElement(i,{id:o,title:e,path:r,...m});export{o as PrintIcon};
